import React from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import { LogoIcon } from '@spa/shared/svg/logo';
import { getHomepageByLocale } from '@spa/shared/utils/redirect';

const LogoUniplaces = ({ onlyIcon }) => {
  const { pathname, locale } = useRouter();

  if (pathname === '/' || /^\/[a-z]{2}$/i.test(pathname)) {
    return <LogoIcon onlyIcon={onlyIcon} />;
  }

  const link = getHomepageByLocale(pathname, locale);

  return (
    <a href={link} title={'Uniplaces'}>
      <LogoIcon onlyIcon={onlyIcon} />
    </a>
  );
};

LogoUniplaces.propTypes = {
  onlyIcon: PropTypes.bool
};

export default LogoUniplaces;
